import { AsyncReturnType } from "type-fest";

import { CampaignService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof CampaignService.deleteTemplate>[0];
type Data = AsyncReturnType<typeof CampaignService.deleteTemplate>;
type Error = unknown;

export const useDeleteTemplate = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    CampaignService.deleteTemplate,
    options
  );

  return result;
};
